let contain = $(".accordion-read-more");
contain.on("click", "[data-action]", function (e) {
  e.preventDefault();
  let action = $(this).data("action");
  if (action === "more") {
    contain.addClass("open");
  } else if (action === "less") {
    contain.removeClass("open");
  }
});